import { createContext, useState, useContext, ReactNode } from "react";
import { CartItemModifierGroupModel } from "../models";

type GiftcardContextType = {
  quantity: number;
  setQuantity: (quantity: number) => void;
  modifierId: string | undefined;
  setModifierId: (id: string | undefined) => void;
  selectedModifiers: CartItemModifierGroupModel[];
  setSelectedModifiers: React.Dispatch<React.SetStateAction<CartItemModifierGroupModel[]>>;
  resetGiftcardForm: () => void;
};

const GiftcardContext = createContext({} as GiftcardContextType);

export function useGiftcard() {
  return useContext(GiftcardContext);
}

export function GiftcardProvider({ children }: { children: ReactNode }) {
  const [quantity, setQuantity] = useState(1);
  const [modifierId, setModifierId] = useState<string | undefined>(undefined);
  const [selectedModifiers, setSelectedModifiers] = useState<CartItemModifierGroupModel[]>([]);

  const resetGiftcardForm = () => {
    setQuantity(1);
    setModifierId(undefined);
    setSelectedModifiers([]);
  };

  return (
    <GiftcardContext.Provider
      value={{
        quantity,
        setQuantity,
        modifierId,
        setModifierId,
        selectedModifiers,
        setSelectedModifiers,
        resetGiftcardForm,
      }}
    >
      {children}
    </GiftcardContext.Provider>
  );
}
